<template>
    <div id="SalesReport">

        <v-row class="mb-2 ml-0">
            <v-icon @click="$router.go(-1)" class="mr-2">mdi-arrow-left</v-icon>
            Reports <v-icon size="16" class="ml-2">mdi-greater-than</v-icon> <span class="font-weight-bold ml-2">{{$route.name}}</span>
        </v-row>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn depressed style="float: right;margin:-36px 0 0 0" class="primary" v-bind="attrs" v-on="on" :loading="exportLoading">Export</v-btn>
            </template>
            <v-list>
                <v-list-item @click="getSalesReport('pdf')" :disabled="disableApplyBtn"><v-list-item-title>Export PDF</v-list-item-title></v-list-item>
<!--                <v-list-item @click="getSalesReport('csv')" :disabled="disableApplyBtn"><v-list-item-title>Export CSV</v-list-item-title></v-list-item>-->
            </v-list>
        </v-menu>

        <v-row>
            <v-col cols="auto">
                <label class="text-uppercase grey--text font-weight-bold" style="display: block; padding-left: 5px">Date</label>
                <date-range v-model="date" auto-apply appendToBody opens="right"> <!-- @update="getSalesReport" -->
                    <template v-slot:input="picker" class="d-flex">
                        <v-icon class="mr-3">mdi-calendar-blank</v-icon>
                        <template>{{ picker.startDate | dateFormat }} - {{ picker.endDate | dateFormat }}</template>
                    </template>
                </date-range>
            </v-col>
            <v-col cols="auto">
                <label class="text-uppercase grey--text font-weight-bold">Customer</label>
                <v-autocomplete outlined :items="customers" :search-input.sync="searchCustomer" placeholder="Search Customer"
                                clearable  @change="onChangeCustomer" v-model="selectedCustomer" no-filter
                                item-text="name" item-value="id" :loading="$apollo.queries.customers.loading">
                    <template v-slot:item="{item}">
                        <v-list-item-avatar>
                            <img :src="imgWpx(item.profileImage, 200)" v-if="item.profileImage" @error="item.profileImage = null">
                            <v-icon size="50" color="blue-grey lighten-4" v-else>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                        <v-list-item-action><v-list-item-action-text v-text="item.mobile"/></v-list-item-action>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="auto">
                <label class="text-uppercase grey--text font-weight-bold">Product</label>
                <v-autocomplete outlined :items="products" :search-input.sync="searchProduct" placeholder="Search Product"
                                clearable @change="onChangeProduct" v-model="selectedProduct" no-filter
                                item-text="name" item-value="id" :loading="$apollo.queries.products.loading">
                    <template v-slot:item="{item}">
                        <v-list-item-avatar><img :src="imgWpx(item.Attachments[0].path, 200)" v-if="item.Attachments.length"></v-list-item-avatar>
                        <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="auto">
                <label class="text-uppercase grey--text font-weight-bold">Group By</label>
                <v-radio-group v-model="tempGroupBy" row>     <!-- @change="getSalesReport" -->
                    <v-radio :label="g.name" :value="g.id" v-for="(g, index) in groupByOptions" :key="index"
                             :disabled="((g.id==='productId'&&selectedProduct)||(g.id==='toCustomerId'&&selectedCustomer))?true:false"/>
                </v-radio-group>
            </v-col>
            <v-col cols="12">
            <v-btn depressed class="mr-4 ml-4 primary" @click="getSalesReport()" :disabled="disableApplyBtn">Apply</v-btn>
            <v-btn outlined @click="onClearFilter">Clear</v-btn>
            <div class="operation-div">
                <span :style="tempShowGroupData === false?'color:#4caf50;padding-top:20px':'padding-top:20px'" @click="tempShowGroupData=false">COMPACT</span>
                <v-switch inset v-model="tempShowGroupData" class="operation-switch pl-4" color="#cc5500"/>
                <span :style="tempShowGroupData?'color:#cc5500;padding-top:20px':'padding-top:20px'" @click="tempShowGroupData=true">DETAIL</span>
            </div>
            </v-col>
        </v-row>

        <v-data-table :headers="[firstColumn, ...headers]" :items="reportData" @update:page="$vuetify.goTo(0)"
                      :footer-props="{itemsPerPageOptions:rowsPerPageItems}" :loading="loading">
            <template v-slot:no-data>No Records Available</template>
            <template v-slot:no-results>No Records Available</template>
<!--            <template v-slot:group.header="{items, isOpen, toggle}">
                <td>
                    <v-icon @click="toggle">mdi-{{ isOpen ? 'chevron-up' : 'chevron-down' }}</v-icon>
                    {{ groupBy === 'created_at'? moment(items[0][groupBy]).format('DD-MM-YYYY'):items[0][groupBy] }}
                </td>
                <td>{{items[0].summary.soldQty}}</td>
                <td>{{items[0].summary.soldAmount}}</td>
                <td>{{items[0].summary.avgAmount}}</td>
            </template>                                      -->
            <template v-slot:body="{ items }">
                <tbody>
                <template v-for="(item, index) in items">                                   <!-- compact/detail view -->
                    <tr :key="index"  @click="toggleGroupRow(item)" :style="item.show?'background: #dedede':''">
                        <td>
                            <v-icon v-show="showGroupData">mdi-{{ item.show ? 'chevron-up' : 'chevron-down' }}</v-icon>
                            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;cursor: pointer" size="60" title="View Image" v-if="item.hasOwnProperty('image')">
                                <v-img v-if="item.image" :src="imgWpx(item.image, 200)" @click.stop="openGallery(([{path: item.image, type: 'IMAGE'}]))" alt="image" @error="item.image = null">
                                    <template v-slot:placeholder>
                                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                    </template>
                                </v-img>
                                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                            </v-avatar>
                            <div style="display: inline-block;vertical-align: middle" v-if="item.hasOwnProperty('mobile')">{{item.name}}<br>{{item.mobile}}</div>
                            <span v-else-if="groupBy === 'created_at'">{{moment(item.name).format('DD-MM-YYYY')}}</span>
                            <span v-else>{{item.name}}</span>
                        </td>
                        <td>{{item.soldQty}}</td>
                        <td>{{Number(item.soldAmount) | currencyFilter}}</td>
                        <td>{{item.avgAmount | currencyFilter}}</td>
                    </tr>
                    <tr v-for="(s, idx) in item.subItems" :key="index+'-'+idx" v-show="item.show">
                        <td style="padding-left: 50px">
                            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;cursor: pointer" size="60" title="View Image" v-if="s.hasOwnProperty('image')">
                                <v-img v-if="s.image" :src="imgWpx(s.image, 200)" @click.stop="openGallery(([{path: s.image, type: 'IMAGE'}]))" alt="image" @error="s.image = null">
                                    <template v-slot:placeholder>
                                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                    </template>
                                </v-img>
                                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                            </v-avatar>
                            <div style="display: inline-block;vertical-align: middle" v-if="s.hasOwnProperty('mobile')">{{s.name}}<br>{{s.mobile}}</div>
                            <span v-else-if="groupBy !== 'created_at'">{{moment(s.name).format('DD-MM-YYYY')}}</span>
                            <span v-else>{{s.name}}</span>
                        </td>
                        <td>{{ s.soldQty }}</td>
                        <td>{{ Number(s.soldAmount) | currencyFilter}}</td>
                        <td>{{ s.avgAmount | currencyFilter }}</td>
                    </tr>
                </template>
                <tr style="color: teal; font-weight: bolder" v-show="items.length">         <!-- table summary -->
                    <td style="font-size: 18px">SUMMARY</td>
                    <td style="font-size: 18px">{{bodyAppendRow.soldQty}}</td>
                    <td style="font-size: 18px">{{bodyAppendRow.soldAmount | currencyFilter}}</td>
                    <td style="font-size: 18px">{{bodyAppendRow.avgAmount | currencyFilter}}</td>
                </tr>
                </tbody>
            </template>
        </v-data-table>

        <Snackbar :toaster="toaster"></Snackbar>
        <gallery id="gallery-sales-report" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
    </div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import {debounce} from "lodash";
import {SEARCH_CUSTOMER_RETURNING_EXTRA_DETAIL} from "../../graphql/queries/Customers";
import {SEARCH_PRODUCT} from "../../graphql/queries/SearchProduct";
import axios from 'axios';
import Vue from 'vue';
import Snackbar from "../../components/Common/Snackbar";

export default {
    name: "ProductCustomerSalesReport",
    components: {Snackbar},
    apollo: {
        customers: {
            query: SEARCH_CUSTOMER_RETURNING_EXTRA_DETAIL,
            variables() {
                return {search: '%' + this.filterCustomer + '%'}
            }
        },
        products: {
            query: SEARCH_PRODUCT,
            variables() {
                return {search: '%' + this.filterProduct + '%'}
            }
        },
    },
    data() {
        return {
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            moment: moment,
            OrderItems: [],
            customers: [],
            selectedCustomer: null,
            searchCustomer: null,
            filterCustomer: null,
            products: [],
            selectedProduct: null,
            searchProduct: null,
            filterProduct: null,
            groupBy: 'productId',
            tempGroupBy: 'productId',
            groupByOptions:[{id:'created_at', name:'Date'},{id:'productId', name:'Product'},
                            {id:'toCustomerId',name:'Customer'}],
            showGroupData: false,
            tempShowGroupData: false,
            reportData: [],
            bodyAppendRow: { soldQty:0, soldAmount:0, avgAmount:0 },               //table summary row
            loading: false,
            exportLoading: false,
            // headers: [
            //     {text: 'DATE', value: 'created_at'}, {text: 'CUSTOMER', value: 'Customer.name'},
            //     {text: 'PRODUCT', value: 'Product.name'}, {text: 'SELL QTY', value: 'qty'},
            //     {text: 'AMOUNT', value: 'amount'}, {text: 'AVG. AMOUNT', value: 'pricePerUnit'}
            // ],
            headers: [{text: 'SELL QTY', value: 'soldQty'}, {text: 'AMOUNT', value: 'soldAmount'},
                      {text: 'AVG. AMOUNT', value: 'avgAmount'}],
            rowsPerPageItems: [25, 50, 100, -1],
            date: {startDate: moment(), endDate: moment()},
            galleryImages: [],
            galleryIndex: null,
            toaster: { enable:false }
        }
    },
    computed:{
        firstColumn(){
            let header = {text: 'PRODUCT', value: 'name'}
            if(['productId','toCustomerId'].includes(this.groupBy)) header.text = 'Date'
            else if(this.groupBy === 'created_at' && this.selectedProduct && this.selectedCustomer) header.text = 'Product'
            else if(this.groupBy === 'created_at' && this.selectedProduct) header.text = 'Customer'
            else if(this.groupBy === 'created_at' && this.selectedCustomer) header.text = 'Product'
            return header
        },
        disableApplyBtn(){
            return (!this.selectedCustomer&&!this.selectedProduct);
        }
    },
    watch: {
        searchCustomer: debounce(function (val) {
            if (val?.length > 1) this.filterCustomer = val
        }, 500),
        searchProduct: debounce(function (val) {
            if (val?.length > 1) this.filterProduct = val
        }, 500)
    },
    methods: {
        onChangeCustomer(){
            if(this.selectedProduct && this.selectedCustomer) this.tempGroupBy = 'created_at'
            else if(!this.selectedProduct && this.selectedCustomer) this.tempGroupBy = 'productId'
            else if(this.selectedProduct && !this.selectedCustomer) this.tempGroupBy = 'toCustomerId'

        },
        onChangeProduct(){
            if(this.selectedProduct && this.selectedCustomer) this.tempGroupBy = 'created_at'
            else if(!this.selectedProduct && this.selectedCustomer) this.tempGroupBy = 'productId'
            else if(this.selectedProduct && !this.selectedCustomer) this.tempGroupBy = 'toCustomerId'
        },
        onClearFilter(){
            this.selectedCustomer = null
            this.selectedProduct = null
            this.reportData = []
        },
        toggleGroupRow(item){
            if(this.showGroupData) Vue.set(item, 'show', !item.show)
        },
        async getSalesReport(exportAs){
            if(!this.selectedCustomer && !this.selectedProduct){
                this.reportData = []
                return
            }

            this[exportAs?'exportLoading':'loading'] = true

            this.groupBy = this.tempGroupBy
            let request = {
                startDate: moment(this.date.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.date.endDate).format('YYYY-MM-DD'),
                groupBy: this.groupBy,
                ...(this.selectedCustomer && {toCustomerId: this.selectedCustomer}),
                ...(this.selectedProduct && {productId: this.selectedProduct}),
                reportType: this.tempShowGroupData ? 1 : 2,
                format: exportAs || 'json'
            }

            try {
                let response = await axios({method:'POST', url: Constants.api_url + 'v1/salesReport', data:request,
                                            ...(exportAs && {responseType: "blob"})})
                if(response.data.flag) {
                    let flatArr = []
                    if (request.format === 'json') this.bodyAppendRow = {soldQty: 0, soldAmount: 0, avgAmount: 0}
                    if ([1,2].includes(request.reportType) && request.format === 'json') {          //Detail/Compact View
                        response.data.data.forEach(g => {
                            this.bodyAppendRow.soldQty += Number(g.soldQty)
                            this.bodyAppendRow.soldAmount += Number(g.soldAmount)
                        })
                        flatArr = response.data.data
                        this.bodyAppendRow.avgAmount = this.bodyAppendRow.soldAmount / this.bodyAppendRow.soldQty
                        this.showGroupData = this.tempShowGroupData
                        this.reportData = flatArr
                        this.loading = false
                    }
                }
                if (['pdf', 'csv'].includes(request.format)) {
                    // console.log('response', response.data)
                    let elem = window.document.createElement('a');
                    elem.href = window.URL.createObjectURL(response.data);
                    elem.download = 'sales_report_'+moment().format('DD-MM-YY HH:mm:ss');
                    document.body.appendChild(elem);
                    elem.click();
                    document.body.removeChild(elem);
                    this.exportLoading = false
                }
            } catch(error){
                this.loading = false
                this.exportLoading = false
                if (error.message === 'Network Error') {
                    this.toaster = {enable:true, color:'red', message: error.message}
                } else this.toaster = {enable:true, color:'red', message: `API Call Fail`}
            }
        },
        openGallery(arr) {
            this.galleryImages = arr.map(m => {
                return {
                    href: this.imgWpx(m.path, 900, m.type),
                    type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
                }
            })
            this.galleryIndex = 0
        }
    }
}
</script>

<style scoped>
    #SalesReport {
        padding: 20px;
    }
    /deep/ .reportrange-text{
        /*width: 212px;*/
        text-align: center;
        padding: 14px 10px;
        border: 1px solid rgba(0,0,0,.14);
        margin: 0px 0px 0px 6px;
    }
    .operation-div{
        display: inline-flex;
        float: right;
        font-size: 16px;
        font-weight: 600;
        color: #c0c0c0;
        height: 16px;
        margin-top: -20px;
        cursor: pointer;
    }
    /deep/ .operation-switch.v-input--switch .v-input--switch__track{
        color: #4caf50;
    }
    /deep/ .operation-switch.v-input--switch .v-input--switch__thumb{
        color: #4caf50;
    }
</style>